import { IStore } from 'store/configureStore';
import { selectControllingOrgState } from 'modules/settings/submodules/clients/controllingOrg/store/selectors';

export const selectControllingOrgFilter = (state: IStore): string => {
    const controllingOrgState = selectControllingOrgState(state);
    return controllingOrgState.controllingOrgFilter;
};
